import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "store",
	"data-name": "store",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "shop",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "plan2plate-icon",
				d: "M7.23,6.27v5.25a2.39,2.39,0,0,1-4.78,0L4.36,6.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "plan2plate-icon",
				d: "M12,6.27v5.25a2.39,2.39,0,1,1-4.77,0V6.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "plan2plate-icon",
				d: "M16.77,6.27v5.25a2.39,2.39,0,1,1-4.77,0V6.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "plan2plate-icon",
				d: "M21.55,11.52a2.39,2.39,0,0,1-4.78,0V6.27h2.87Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "plan2plate-icon",
				d: "M19.64,13.91V22.5H4.36V13.91h.48a2.39,2.39,0,0,0,2.39-2.39,2.39,2.39,0,1,0,4.77,0,2.39,2.39,0,1,0,4.77,0,2.39,2.39,0,0,0,2.39,2.39Z"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				className: "plan2plate-icon",
				points: "1.5 22.5 4.36 22.5 19.64 22.5 22.5 22.5"
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "plan2plate-icon",
				x: 6.27,
				y: 1.5,
				width: 11.45,
				height: 4.77
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "plan2plate-icon",
				x: 8.18,
				y: 17.73,
				width: 7.64,
				height: 4.77
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgStore);
export default ForwardRef;
